module.exports = __webpack_public_path__ + "static/media/product mobile.8370d5b0.webp";